import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_OUTSTANDING_BILLS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetAllOutstandingBillTransformedResult,
  GetOutstandingBillsPayload,
} from '../types/getOutstandingBills.types';

export const OUTSTANDING_BILLS = 'OutstandingBill';

export const getOutstandingBills = (builder: BuilderType) =>
  builder.query<GetAllOutstandingBillTransformedResult, GetOutstandingBillsPayload>({
    keepUnusedDataFor: 0,
    providesTags: [OUTSTANDING_BILLS],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PAYMENTS_OUTSTANDING_BILLS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetAllOutstandingBillTransformedResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return {
          ...response.Result,
          message: response.Message,
          status: response.Status,
        };
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
